import { useEffect } from "react";

function isInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return false; // Assuming in an iframe if accessing window.top causes an error
  }
}

const useSendHeightToParent = () => {
  useEffect(() => {
    const sendHeight = () => {
      const height = document.documentElement.scrollHeight;
      window.parent.postMessage(
        {
          type: "setHeight",
          height,
        },
        "*"
      ); // Note: Specify the parent domain here instead of '*' for security
    };

    setTimeout(sendHeight, 100);

    // Observe for any height changes
    const observer = new ResizeObserver(() => {
      setTimeout(sendHeight, 100);
    });
    observer.observe(document.body);

    // Clean up
    return () => observer.disconnect();
  }, []);
};

export default useSendHeightToParent;

export { isInIframe, useSendHeightToParent };
